import { values } from 'lodash';
import * as React from 'react';
import * as firebase from 'firebase/app';
import { Card, Icon, Button } from 'antd';
import { Subscription } from 'rxjs';
import { snapShot$ } from 'src/util';

interface ToolAction {
  name: string;
  status: 'waiting' | 'processing' | 'done';
}
type S = {
  status: 'none' | 'requested' | 'ready';
} | {
  status: 'processing' | 'ready';
  actions: { [step: string]: ToolAction };
}

const ToolActionItem = ({ status, name }: ToolAction) => {
  const icon = status === 'done' ?
    <Icon type="check-circle" theme="filled" style={{ color: '#5cb85c' }} />
    : status === 'processing' ?
      <Icon type="loading" />
      : <Icon type="check-circle" style={{ opacity: 0.4 }} />;
  return (
    <li>
      {icon}
      <span className={status}>
        {name}
      </span>
    </li>
  );
};

export default class extends React.Component<{}, S> {
  subscription: Subscription;
  doc: firebase.firestore.DocumentReference;

  constructor(props: {}) {
    super(props);

    this.state = {
      status: 'none'
    };
    this.subscription = new Subscription();
    this.doc = firebase.firestore().doc(`tools/syncDb`);
  }

  componentDidMount() {
    this.subscription = snapShot$(this.doc).subscribe(sn => {
      if (!sn.exists) {
        this.setState({ status: 'ready' });
      } else {
        const s = sn.data() as S;
        this.setState(s);
      }
    });
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  handleClick = async () => {
    this.setState({ status: 'requested' });

    await firebase.firestore().runTransaction(async tnx => {
      tnx.set(this.doc, {
        status: 'requested',
      });

      tnx.set(this.doc.collection('requests').doc(), {
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      });
    });
  }

  renderSteps = () => {
    if (this.state.status === 'processing') {
      const { actions } = this.state;
      const items = values(actions)
        .map((ta, i) => (
          <ToolActionItem key={i} {...ta} />
        ));
      return (
        <ul className="tool-actions">
          {items}
        </ul>
      )
    }

    return null;
  }

  render() {
    const { status } = this.state;
    return (
      <Card className="tool-container">
        <Icon type="sync" className="tool-icon" />
        <h2>Sync to DB</h2>

        <p>
          Click the button to sync data to reporting database.
          It will <strong>DELETE</strong> all the data in reporting database
        and re-insert from primary database.
         </p>
        <Button
          icon="sync"
          type='primary'
          disabled={status === 'none'}
          onClick={this.handleClick}
          loading={status === 'processing' || status === 'requested'}
        >
          Sync
        </Button>
        {this.renderSteps()}
      </Card>
    );
  }
}


// WEBPACK FOOTER //
// ./src/tools/SyncDb.tsx